<!-- Translated: yes -->
<template>
  <Modal @close="localCloseModal" :wide="false" :width="'500px'" min-width="420px">

    <div v-if="keycard.pool_lid">

      <div class="padding">
        <h1>Oladdade liftkort</h1>

        <div class="blocked center">
          <b class="uppercase block">Antal liftkort</b>
          <CounterButton ref="counterButton" class="counter-button" :inline="true" :count="peopleCount" :min="1" @changedCount="changePeople($event)" :suffix="' ' + $t('general.pieces-short')" />
        </div>
      </div>

      <div class="blocked info blue">
        Liftkortet kostar {{ keycard.price | currency }} och skickas hem till dig. Leveransen tar ca en vecka.
        <span v-if="SITE_CONFIG.site === 'branas'">Du vet väl att du kan lägga till liftkort till din skidhyra eller till din boendebokning och få leverans tillsammans med nycklar eller skidutrustning.</span>
        <span v-if="SITE_CONFIG.site === 'kungsberget'">Du vet väl att du även kan lägga till liftkort till din skidhyra eller till din boendebokning.</span>
        <span v-if="SITE_CONFIG.site === 'vallasen' || SITE_CONFIG.site === 'ulricehamn'">Du vet väl att du kan lägga till liftkort till din skidhyra och få dem levererade tillsammans med skidutrustningen.</span>
      </div>

      <div class="padding">
        <div class="blocked center">
          <button @click="startBooking()" :disabled="!validate()">{{ $t('general.cta.book') }} <icon name="arrow-white" :scale="1.4" /></button>
        </div>
      </div>

    </div>

    <div class="padding" v-else>
      <h1>Oladdade liftkort</h1>

      <div class="blocked info-box center">
        Oops, det finns inget oladdat liftkort att köpa här för tillfället. Kontakta gärna gästservice om du har några frågor: <a href="tel:054-13 26 00">054-13 26 00</a>
      </div>
    </div>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import CounterButton from '@/components/components/CounterButton';
import Dropdown from '@/components/components/Dropdown';

import API from '@/classes/API';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CounterButton,
    Dropdown,
    LanguageSwitcher,
  },
  data() {
    return {
      peopleCount: 1,
      keycard: {},
    };
  },
  async mounted() {
    const { data } = await API.get('products?tag=keycard-post');
    if (data.length) {
      this.keycard = data[0];
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'addProduct',
    ]),
    localCloseModal() {
      this.closeModal();
    },
    validate() {
      let errors = 0;
      errors += (this.peopleCount ? 0 : 1);
      return !errors;
    },
    startBooking() {
      this.addProduct({
        quantity: this.peopleCount,
        price: this.keycard.price,
        poolId: this.keycard.pool_lid,
        name: this.keycard.name,
      });

      this.closeAllModals();

      const name = this.keycard.name;

      this.$router.push({ path: `/varukorg?show-confirmation=1&ref=product&text=${name}` });
    },
    changePeople(payload) {
      this.peopleCount = payload;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.blocked
  margin-bottom space-2
  max-width:100%;
  margin-left: auto;
  margin-right: auto;

.uppercase
  font-size: 11px
  margin-bottom: 5px

.info
  info-box()
  text-align center

.language-switcher
  margin-top 25px
</style>



// WEBPACK FOOTER //
// SkiPassPickDateKeycard.vue?1238f179